<template>
  <div class="modal-card" style="width: 500px">
    <b-message
      title="Un problème est survenu"
      type="is-danger"
      @close="$emit('close')">
      <div class="content">
        Les faces suivantes ne sont plus disponibles
        <ul>
          <li
            v-for="(faces, index) in faces"
            :key="index">
            Face: {{faces.facCode}}
          </li>
        </ul>
      </div>
    </b-message>
  </div>
</template>

<script>
export default {
  props: {
    faces: Array,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/ErreurFaceDisponible.vue